export const pluralize = (number: number, word: string, postfix?: string): string => {
    return number === 1 ? word : `${word}${postfix ? postfix : 's'}`
}